import {computedFrom} from 'aurelia-framework';
import moment from 'moment';

export class DiscountCoupon {
  constructor(data) {
    Object.assign(this, data);
  }
}
